// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"3e94b0b8","110":"6e37a169","213":"11cb9863","455":"0528d626","512":"e4a66787"}[chunkId] + ".chunk.js";
};